import { render, staticRenderFns } from "./courseDetails.vue?vue&type=template&id=b9ae8c3a&scoped=true&"
import script from "./courseDetails.vue?vue&type=script&lang=js&"
export * from "./courseDetails.vue?vue&type=script&lang=js&"
import style0 from "./courseDetails.vue?vue&type=style&index=0&id=b9ae8c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ae8c3a",
  null
  
)

export default component.exports